import React, { useState, useEffect } from "react";
import { Row, Col, Card, Modal, Button, Form, Image } from "react-bootstrap";

const Directions = ({ initialData, onUpdate }) => {
  const [showModal, setShowModal] = useState(false);
  const [description, setDescription] = useState(initialData || "Not Set"); // Initialize with initialData
  const [tempDescription, setTempDescription] = useState(description);

  useEffect(() => {
    setDescription(initialData || "Not Set");
  }, [initialData]);

  const handleShow = () => {
    setTempDescription(description); // Set input field with existing value
    setShowModal(true);
  };

  const handleClose = () => setShowModal(false);

  const handleSave = () => {
    // setDescription(tempDescription.trim() || "Not Set"); // Update main screen, fallback to "Not Set"
    onUpdate(tempDescription.trim());
    setShowModal(false);
  };
  return (
    <>
      <Row className="px-4 body-font">
        <Col>
          <Card className="business_details_border">
            <Card.Header className="px-4 body-font fw-bold fs-two d-flex justify-content-between business_info_card_header">
              <div className="d-flex black-color" style={{ gap: "12px" }}>
                <Image src="/assets/map-pin.svg" alt="Direction" />
                Direction
              </div>
              {/* Edit button to trigger modal */}
              <div
                className="d-flex gap-1 align-items-center cursor-pointer"
                onClick={handleShow}
                style={{ cursor: "pointer" }}
              >
                <Image
                  src="/assets/edit-1.svg"
                  alt="Edit"
                  className="business-info-icon"
                />
                <span className="fs-four" style={{ color: "#5925DC" }}>
                  Edit
                </span>
              </div>
            </Card.Header>

            <Card.Body className="p-4 d-flex flex-column gap-4">
              <p
                className={`${
                  description === "Not Set" ? "gray-color" : "black-color"
                } mb-0 fs-6 fw-normal`}
              >
                {description}
              </p>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Modal for Editing */}
      <Modal show={showModal} onHide={handleClose} centered size="lg">
        <Modal.Header
          closeButton
          className="business-hrs-border-bottom"
          style={{ backgroundColor: "#FAFAFA" }}
        >
          <Modal.Title className="fw-medium black-color fs-five">
            Directions
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="direction-modal-body">
          <Form>
            <Form.Group controlId="directionDescription">
              <Form.Control
                as="textarea"
                rows={4}
                placeholder="Enter a description..."
                value={tempDescription}
                onChange={(e) => setTempDescription(e.target.value)}
                className="border-1 directions-placeholder"
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer className="gap-4 business-info-modal-footer">
          <span className="gray-color fs-four m-0">
            Changes will go live immediately
          </span>
          <div className="gap-3 m-0 d-flex">
            <Button
              className="m-0 direction-modal-button fw-bold fs-four border-0 direction-modal-cancel"
              onClick={handleClose}
            >
              Cancel
            </Button>
            <Button
              className="direction-modal-button m-0 btn-primary-style fw-bold px-3 fs-four"
              style={{ color: "#ffffff" }}
              onClick={handleSave}
            >
              Save
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Directions;
